import React, { useState } from "react";
import { useLocation } from 'react-router';
import { useFetchAuth } from './../../services/authentication/auth';
import HeaderBar from '../header';
import Spinner from './../Spinner';

import { Layout } from 'antd';
const { Content, Footer } = Layout;

const ProtectedLayout = ({
    children,
    ...props
}) => {
    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    const { auth, loading } = useFetchAuth({ required: true, location: location.pathname });

    // save the protect location, so we can redirect after login.
    localStorage.setItem('last_url', location.pathname);

    if (loading) {
        return (<Spinner />);
    } else {

        return (
            <Layout className="layout">
                {/* header bar */}
                {!loading && (
                    <HeaderBar
                        auth={auth} {...props}
                        collapsed={collapsed}
                        setCollapsed={setCollapsed}
                        className="header" />
                )}

                {/* content section */}
                <Content className="site-layout-background ant-container-wrap" style={{ minHeight: '85vh', }}>
                    <div className="ant-main-content-wrapper">
                        {children}
                    </div>
                </Content>

                {/* footer section */}
                <Footer style={{ textAlign: 'center' }}>Traders Management ©{new Date().getFullYear()}</Footer>
            </Layout>
        );
    };
};

export default ProtectedLayout;
